import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserAccessesComponent } from '@app/core/header/components/user-accesses/user-accesses.component';
import { reducers } from '@app/core/header/store';
import { AuthButtonModule } from '@app/core/user/components/auth-button/auth-button.module';
import { CartButtonModule } from '@app/shared/components/cart-button/cart-button.module';
import { NotificationsModule } from '@app/core/header/components/notifications/notifications.module';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { WindowRefService } from '@app/shared/services/windowRef/window-ref.service';
import { SharedModule } from '@app/shared/shared.module';
import { StoreModule } from '@ngrx/store';

import { SearchbarModule } from '@app/shared/components/searchbar/searchbar.module';
import { HeaderComponent } from './header.component';
import { FloatingCartModule } from '@app/core/header/components/floating-cart/floating-cart.module';
import { MainNavComponent } from '@app/core/header/components/main-nav/main-nav.component';
import { PreviewBoxComponent } from '@app/core/header/components/preview-box/preview-box.component';
import { ProfileAccessComponent } from '@app/core/header/components/profile-access/profile-access.component';
import { WishListPreviewModule } from '@app/core/header/components/wishlist-preview/wishlist-preview.module';
import { UnderlineDirective } from '@app/core/header/directives/underline/underline.directive';
import { UsersService } from '@vestiaire/api-sdk-angular';

// Only here for A/B test
import { PromoBannerModule } from '@app/core/promo-banner/promo-banner.module';
// To remove after
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot({}),
    StoreModule.forFeature('header', reducers),
    SharedModule,
    CartButtonModule,
    FloatingCartModule,
    NotificationsModule,
    WishListPreviewModule,
    RouterModule,
    AuthButtonModule,
    SearchbarModule,
    PromoBannerModule
  ],
  declarations: [
    HeaderComponent,
    MainNavComponent,
    UserAccessesComponent,
    PreviewBoxComponent,
    ProfileAccessComponent,
    UnderlineDirective
  ],
  exports: [HeaderComponent],
  providers: [HelpersService, WindowRefService, UsersService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderModule {}
